import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
// Betrun şemasının görünümü en sona bağlanır: kurulumların özel CSS'i gibi
// diğer bütün stillerden sonra gelmelidir (bkz. dosyanın başlığı).
import "@/themes/betrun/betrunSkin.css";
import { restoreSkinFlag } from "@/lib/betrunSkin";

// Paketlenmiş Betrun görünümünün son bilinen kararı ilk boyamadan önce
// uygulanır (bkz. lib/betrunSkin.js); ayarlar gelince yeniden verilir.
restoreSkinFlag();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
